function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@mdi/react';
import IconButton from '@material-ui/core/IconButton';
import { mdiDownload } from '@mdi/js';
import { Typography, useTheme } from '@material-ui/core';
import { Button, renderStyledColor } from '@tecsinapse/ui-kit';
import { exportToCSV, isRemoteData } from '../utils/tableFunctions';
var defaultLabelToCSV = 'Export to CSV';

var exportTo = function exportTo(type, exportFileName, columns, data, delimeter, setAnchorEl) {
  if (type === 'csv') {
    exportToCSV(exportFileName, columns, data, delimeter);
  }

  setAnchorEl(null);
};

var exportData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type, exportFileName, columns, data, setAnchorEl, delimeter, filters, setLoading, rowCount) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);

            if (isRemoteData(data)) {
              data(_objectSpread(_objectSpread({}, filters), {
                page: 0,
                rowsPerPage: rowCount
              })).then(function (_ref2) {
                var resultData = _ref2.data;
                exportTo(type, exportFileName, columns, resultData, delimeter, setAnchorEl);
                setLoading(false);
              });
            } else {
              exportTo(type, exportFileName, columns, data, delimeter, setAnchorEl);
              setLoading(false);
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exportData(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref.apply(this, arguments);
  };
}();

var Exporter = function Exporter(_ref3) {
  var exportFileName = _ref3.exportFileName,
      exportTypes = _ref3.exportTypes,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 'header' : _ref3$position,
      data = _ref3.data,
      columns = _ref3.columns,
      filters = _ref3.filters,
      setLoading = _ref3.setLoading,
      rowCount = _ref3.rowCount;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var theme = useTheme();

  if (!exportTypes || exportTypes.length === 0) {
    return null;
  }

  var handleExport = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type, delimeter, exportFunc) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(exportFunc || type === 'custom')) {
                _context2.next = 5;
                break;
              }

              exportFunc();
              setAnchorEl(false);
              _context2.next = 7;
              break;

            case 5:
              _context2.next = 7;
              return exportData(type, exportFileName, columns, data, setAnchorEl, delimeter, filters, setLoading, rowCount);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleExport(_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }();

  if (position === 'footer') {
    var _exportTypes$2;

    var whiteSpace = {
      whiteSpace: 'nowrap'
    };
    var typoLabel = {
      fontWeight: '500',
      fontSize: '0.875rem'
    };
    return /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        var _exportTypes$;

        return (_exportTypes$ = exportTypes[0]) === null || _exportTypes$ === void 0 ? void 0 : _exportTypes$.exportFunc();
      },
      style: whiteSpace,
      variant: "contained",
      color: renderStyledColor(theme.variant),
      size: "small"
    }, /*#__PURE__*/React.createElement(Icon, {
      path: mdiDownload,
      size: 1,
      color: theme.palette.primary.contrastText
    }), /*#__PURE__*/React.createElement(Typography, {
      style: typoLabel
    }, (_exportTypes$2 = exportTypes[0]) === null || _exportTypes$2 === void 0 ? void 0 : _exportTypes$2.label));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    path: mdiDownload,
    size: 1,
    color: "#757575"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      return setAnchorEl(null);
    }
  }, exportTypes.map(function (_ref5) {
    var type = _ref5.type,
        label = _ref5.label,
        delimeter = _ref5.delimeter,
        exportFunc = _ref5.exportFunc;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "export-".concat(type),
      onClick: function onClick() {
        return handleExport(type, delimeter, exportFunc);
      }
    }, label || defaultLabelToCSV);
  })));
};

Exporter.defaultProps = {
  data: [],
  exportFileName: 'table_exporter',
  exportTypes: []
};
Exporter.propTypes = {
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.func]),
  exportFileName: PropTypes.string,
  exportTypes: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['csv', 'custom']),
    label: PropTypes.string,
    delimeter: PropTypes.string,
    exportFunc: PropTypes.func
  }))
};
export default Exporter;